// extracted by mini-css-extract-plugin
export default {"wrapper":"Admins_wrapper__AvPDo"};